export default "__VITE_PUBLIC_ASSET__51bbeac2__"